import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const categories = [
  { id: 'rights', name: 'Rights & Responsibilities', icon: '⚖️', count: 30 },
  { id: 'aboriginal', name: 'Aboriginal Peoples', icon: '🪶', count: 30 },
  { id: 'languages', name: 'English & French', icon: '🗣️', count: 30 },
  { id: 'diversity', name: 'Canadian Diversity', icon: '🌍', count: 30 },
  { id: 'exploration', name: 'Early Exploration', icon: '⛵', count: 30 },
  { id: 'struggle', name: 'Struggle for Continent', icon: '⚔️', count: 30 },
  { id: 'war1812', name: 'War of 1812', icon: '🎖️', count: 30 },
  { id: 'confederation', name: 'Confederation', icon: '🏛️', count: 30 },
  { id: 'expansion', name: 'Western Expansion', icon: '🚂', count: 30 },
  { id: 'wwi', name: 'World War I', icon: '🎗️', count: 30 },
  { id: 'wwii', name: 'World War II', icon: '✈️', count: 30 },
  { id: 'modern', name: 'Modern Canada', icon: '🏙️', count: 30 },
  { id: 'government', name: 'Government System', icon: '🏛️', count: 40 },
  { id: 'elections', name: 'Elections', icon: '🗳️', count: 33 },
  { id: 'justice', name: 'Justice System', icon: '⚖️', count: 29 },
  { id: 'symbols', name: 'Canadian Symbols', icon: '🍁', count: 47 },
  { id: 'economy', name: 'Economy & Trade', icon: '💼', count: 32 },
  { id: 'regions', name: 'Regions & Geography', icon: '🗺️', count: 56 }
];

export default function CategorySelection() {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleCategorySelect = (categoryId) => {
    setSelectedCategory(categoryId);
    // Navigate to difficulty selection with category
    navigate(`/difficulty?category=${categoryId}`);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 to-purple-800 p-6">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-lg shadow-xl p-8">
          <div className="flex items-center justify-between mb-8">
            <h1 className="text-3xl font-bold text-gray-800">Select a Topic</h1>
            <button
              onClick={() => navigate('/dashboard')}
              className="btn btn-secondary"
            >
              ← Back
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {categories.map((category) => (
              <div
                key={category.id}
                onClick={() => handleCategorySelect(category.id)}
                className="card hover:shadow-lg cursor-pointer transition-all transform hover:scale-105 p-6 border-2 border-transparent hover:border-purple-500"
              >
                <div className="flex items-center space-x-4">
                  <div className="text-4xl">{category.icon}</div>
                  <div className="flex-1">
                    <h3 className="font-bold text-lg text-gray-800">{category.name}</h3>
                    <p className="text-gray-600 text-sm">{category.count} questions</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 text-center">
            <p className="text-gray-600">Total: 597 questions across 18 topics</p>
          </div>
        </div>
      </div>
    </div>
  );
}
